var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixStoresV2Orders from '@wix/ambassador-stores-v2-orders/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNSPECIFIED_IDENTITY_TYPE"] = "UNSPECIFIED_IDENTITY_TYPE";
    /** Site member */
    IdentityType["MEMBER"] = "MEMBER";
    /** Contact */
    IdentityType["CONTACT"] = "CONTACT";
})(IdentityType || (IdentityType = {}));
export var WeightUnit;
(function (WeightUnit) {
    /** Weight unit can't be classified, due to an error */
    WeightUnit["UNSPECIFIED_WEIGHT_UNIT"] = "UNSPECIFIED_WEIGHT_UNIT";
    /** Kilograms */
    WeightUnit["KG"] = "KG";
    /** Pounds */
    WeightUnit["LB"] = "LB";
})(WeightUnit || (WeightUnit = {}));
/** Brazilian tax info types */
export var VatType;
(function (VatType) {
    /** When the tax info type can't be classified, due to an error */
    VatType["UNSPECIFIED_TAX_TYPE"] = "UNSPECIFIED_TAX_TYPE";
    /** CPF - for individual tax payers */
    VatType["CPF"] = "CPF";
    /** CNPJ - for corporations */
    VatType["CNPJ"] = "CNPJ";
})(VatType || (VatType = {}));
/** This might be extended in the future with pending orders statuses */
export var PaymentStatus;
(function (PaymentStatus) {
    /** Payment status can't be classified, due to an error */
    PaymentStatus["UNSPECIFIED_PAYMENT_STATUS"] = "UNSPECIFIED_PAYMENT_STATUS";
    /** Order is pending response from the payment provider */
    PaymentStatus["PENDING"] = "PENDING";
    /** Order is marked as not paid, and can be marked as paid later on. This is relevant for POS and offline orders */
    PaymentStatus["NOT_PAID"] = "NOT_PAID";
    /** The order is marked as paid */
    PaymentStatus["PAID"] = "PAID";
    /** Order was refunded, refund amount less than order total price */
    PaymentStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    /** Full order total price was refunded */
    PaymentStatus["FULLY_REFUNDED"] = "FULLY_REFUNDED";
    /** At least one payment was received and approved, covering less than total price amount */
    PaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
})(PaymentStatus || (PaymentStatus = {}));
export var FulfillmentStatus;
(function (FulfillmentStatus) {
    /** None of the order items are fulfilled */
    FulfillmentStatus["NOT_FULFILLED"] = "NOT_FULFILLED";
    /**
     * All of the order items are fulfilled
     * Orders without shipping info are fulfilled automatically
     */
    FulfillmentStatus["FULFILLED"] = "FULFILLED";
    /** Order is canceled */
    FulfillmentStatus["CANCELED"] = "CANCELED";
    /** Some, but not all of the order items are fulfilled */
    FulfillmentStatus["PARTIALLY_FULFILLED"] = "PARTIALLY_FULFILLED";
})(FulfillmentStatus || (FulfillmentStatus = {}));
export var LineItemType;
(function (LineItemType) {
    /** Line item type can't be classified, due to an error */
    LineItemType["UNSPECIFIED_LINE_ITEM_TYPE"] = "UNSPECIFIED_LINE_ITEM_TYPE";
    /** Physical item type */
    LineItemType["PHYSICAL"] = "PHYSICAL";
    /** Digital item type */
    LineItemType["DIGITAL"] = "DIGITAL";
    /** Custom item price */
    LineItemType["CUSTOM_AMOUNT_ITEM"] = "CUSTOM_AMOUNT_ITEM";
})(LineItemType || (LineItemType = {}));
export var MediaItemType;
(function (MediaItemType) {
    /** Media item type can't be classified, due to an error */
    MediaItemType["UNSPECIFIED_MEDIA_TYPE_ITEM"] = "UNSPECIFIED_MEDIA_TYPE_ITEM";
    /** Image item type */
    MediaItemType["IMAGE"] = "IMAGE";
})(MediaItemType || (MediaItemType = {}));
export var ActivityType;
(function (ActivityType) {
    /** Activity item type can't be classified, due to an error */
    ActivityType["UNSPECIFIED_ORDER_HISTORY_ITEM_TYPE"] = "UNSPECIFIED_ORDER_HISTORY_ITEM_TYPE";
    /** Store owner added a comment */
    ActivityType["MERCHANT_COMMENT"] = "MERCHANT_COMMENT";
    /** Order placed */
    ActivityType["ORDER_PLACED"] = "ORDER_PLACED";
    /** Order marked as paid, either by the store owner (for offline orders), or when an online transaction was confirmed */
    ActivityType["ORDER_PAID"] = "ORDER_PAID";
    /** Order shipping status set as fulfilled */
    ActivityType["ORDER_FULFILLED"] = "ORDER_FULFILLED";
    /** Order shipping status set as not fulfilled */
    ActivityType["ORDER_NOT_FULFILLED"] = "ORDER_NOT_FULFILLED";
    /** A download link was sent (relevant for orders with digital line items) */
    ActivityType["DOWNLOAD_LINK_SENT"] = "DOWNLOAD_LINK_SENT";
    /** An email notification for pickup was sent */
    ActivityType["PICKUP_READY_EMAIL_SENT"] = "PICKUP_READY_EMAIL_SENT";
    /** Shipping tracking number was set */
    ActivityType["TRACKING_NUMBER_ADDED"] = "TRACKING_NUMBER_ADDED";
    /** Shipping tracking number was edited */
    ActivityType["TRACKING_NUMBER_EDITED"] = "TRACKING_NUMBER_EDITED";
    /** Shipping tracking link was set */
    ActivityType["TRACKING_LINK_WAS_SET"] = "TRACKING_LINK_WAS_SET";
    /** An email confirmation of order shipment was sent */
    ActivityType["SHIPPING_CONFIRMATION_EMAIL_SENT"] = "SHIPPING_CONFIRMATION_EMAIL_SENT";
    /** Invoice was set in the order */
    ActivityType["INVOICE_WAS_SET"] = "INVOICE_WAS_SET";
    /** Invoice was removed from the order */
    ActivityType["INVOICE_WAS_REMOVED"] = "INVOICE_WAS_REMOVED";
    /** Invoice was sent to customer via email */
    ActivityType["INVOICE_WAS_SENT"] = "INVOICE_WAS_SENT";
    /** Email was sent to fulfiller */
    ActivityType["FULFILLER_EMAIL_SENT"] = "FULFILLER_EMAIL_SENT";
    /** Shipping address was updated */
    ActivityType["SHIPPING_ADDRESS_EDITED"] = "SHIPPING_ADDRESS_EDITED";
    /** Order email was updated */
    ActivityType["EMAIL_EDITED"] = "EMAIL_EDITED";
    /** Order partially paid. During the checkout for orders with deposit items. */
    ActivityType["ORDER_PARTIALLY_PAID"] = "ORDER_PARTIALLY_PAID";
})(ActivityType || (ActivityType = {}));
export var InvoiceSource;
(function (InvoiceSource) {
    /** Invoice source can't be classified, due to an error */
    InvoiceSource["UNSPECIFIED_INVOICE_SOURCE"] = "UNSPECIFIED_INVOICE_SOURCE";
    /** Invoice created using the Invoices API */
    InvoiceSource["WIX"] = "WIX";
})(InvoiceSource || (InvoiceSource = {}));
export var ChannelType;
(function (ChannelType) {
    ChannelType["UNSPECIFIED"] = "UNSPECIFIED";
    ChannelType["WEB"] = "WEB";
    ChannelType["POS"] = "POS";
    ChannelType["EBAY"] = "EBAY";
    ChannelType["AMAZON"] = "AMAZON";
    ChannelType["OTHER_PLATFORM"] = "OTHER_PLATFORM";
    ChannelType["WIX_APP_STORE"] = "WIX_APP_STORE";
    ChannelType["WIX_INVOICES"] = "WIX_INVOICES";
    ChannelType["BACKOFFICE_MERCHANT"] = "BACKOFFICE_MERCHANT";
    ChannelType["WISH"] = "WISH";
    ChannelType["CLASS_PASS"] = "CLASS_PASS";
    ChannelType["GLOBAL_E"] = "GLOBAL_E";
    ChannelType["FACEBOOK"] = "FACEBOOK";
    ChannelType["ETSY"] = "ETSY";
    ChannelType["TIKTOK"] = "TIKTOK";
    ChannelType["FAIRE_COM"] = "FAIRE_COM";
})(ChannelType || (ChannelType = {}));
export var EnteredByIdentityType;
(function (EnteredByIdentityType) {
    EnteredByIdentityType["USER"] = "USER";
    EnteredByIdentityType["MEMBER"] = "MEMBER";
    EnteredByIdentityType["CONTACT"] = "CONTACT";
    EnteredByIdentityType["APP"] = "APP";
})(EnteredByIdentityType || (EnteredByIdentityType = {}));
/** Frequency unit of recurring payment */
export var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency || (SubscriptionFrequency = {}));
/** This may be expanded in the future to include partial fulfillments */
export var ShipmentFulfillmentStatus;
(function (ShipmentFulfillmentStatus) {
    /** Shipment fulfillment status can't be classified, due to an error */
    ShipmentFulfillmentStatus["UNSPECIFIED_SHIPMENT_FULFILLMENT_STATUS"] = "UNSPECIFIED_SHIPMENT_FULFILLMENT_STATUS";
    /** Entire order's shipment is not fulfilled */
    ShipmentFulfillmentStatus["SHIPMENT_NOT_FULFILLED"] = "SHIPMENT_NOT_FULFILLED";
    /** Entire order's shipment is fulfilled */
    ShipmentFulfillmentStatus["SHIPMENT_FULFILLED"] = "SHIPMENT_FULFILLED";
})(ShipmentFulfillmentStatus || (ShipmentFulfillmentStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _addFulfillerEmailWasSentActivityRequest = {};
const _addFulfillerEmailWasSentActivityResponse = {};
const _bulkArchiveOrdersRequest = {};
const _bulkArchiveOrdersResponse = {};
const _bulkFulfillOrdersRequest = {};
const _bulkFulfillOrdersResponse = {};
const _bulkMarkOrdersAsPaidRequest = {};
const _bulkMarkOrdersAsPaidResponse = {};
const _bulkUnarchiveOrdersRequest = {};
const _bulkUnarchiveOrdersResponse = {};
const _createFulfillmentRequest = {};
const _createFulfillmentResponse = {};
const _createOrderRequest = {};
const _createOrderResponse = {};
const _declineOrderRequest = {};
const _declineOrderResponse = {};
const _deleteFulfillmentRequest = {};
const _deleteFulfillmentResponse = {};
const _getOrderRequestV2 = {};
const _getOrderResponseV2 = {};
const _markAsPaidRequest = {};
const _markAsPaidResponse = {};
const _markAsReadRequest = {};
const _markAsReadResponse = {};
const _queryOrdersRequestV2 = {};
const _queryOrdersResponseV2 = {};
const _sendFulfillmentConfirmationRequest = {};
const _sendFulfillmentConfirmationResponse = {};
const _setArchiveStatusRequest = {};
const _setArchiveStatusResponse = {};
const _setShippingFulfillmentRequest = {};
const _setShippingFulfillmentResponse = {};
const _updateFulfillmentRequest = {};
const _updateFulfillmentResponse = {};
const _updateOrderEmailRequest = {};
const _updateOrderEmailResponse = {};
const _updateOrderShippingAddressRequest = {};
const _updateOrderShippingAddressResponse = {};
/**
 * Add payment data for an order
 * @param _id - The order id
 * @param paymentInfo - The payment info
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField paymentInfo
 * @adminMethod
 */
export function markAsPaid(_id, paymentInfo) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]', paymentInfo: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _markAsPaidRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _markAsPaidResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, paymentInfo]);
        const reqOpts = ambassadorWixStoresV2Orders.markAsPaid(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'paymentInfo',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Set order's shipping's fulfillment status
 * @param _id - The order id
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function setShippingFulfillment(_id, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]', status: '$[1].status' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _setShippingFulfillmentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _setShippingFulfillmentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, options]);
        const reqOpts = ambassadorWixStoresV2Orders.setShippingFulfillment(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Send confirmation mail for either pickup/shipment fulfillment
 * @param _id - The order id
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function sendFulfillmentConfirmation(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _sendFulfillmentConfirmationRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _sendFulfillmentConfirmationResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixStoresV2Orders.sendFulfillmentConfirmation(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Mark order as read
 * @param _id - The order id
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function markAsRead(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _markAsReadRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _markAsReadResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixStoresV2Orders.markAsRead(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Set order's archive status
 * @param _id - The order id
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function setArchiveStatus(_id, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]', archived: '$[1].archived' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _setArchiveStatusRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _setArchiveStatusResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, options]);
        const reqOpts = ambassadorWixStoresV2Orders.setArchiveStatus(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Create Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/create-order)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Creates a new order.
 *
 * > **Notes:**
 * > + Only orders with the `paymentStatus` parameter set as `"PAID"` or `"NOT_PAID"` will show up in the site owner's Stores Orders tab in their dashboard.
 * > + The `billingInfo.paymentProviderTransactionId` and `billingInfo.paymentMethod` parameters can only be passed when paymentStatus is PAID.
 * > + The `billingInfo`.address parameter is required unless `channelInfo.type: "POS"`.
 * > + The `shippingInfo.shipmentDetails.address` parameter is required unless one of the following is true:
 * >   + The `shippingInfo.pickupDetails` is passed instead
 * >   + `channelInfo.type: "POS"`
 * >   + All order items are of type digital - `lineItems.lineItemType: "DIGITAL"`.
 * > + When passing `lineItems.variantId`, `lineItems.options` is required.
 * > + When passing `lineItems.productId`, `lineItem.lineItemType` is limited to `"PHYSICAL"`.
 * > + When not passing `lineItems.productId`, `lineItem.lineItemType` is limited to `"CUSTOM_AMOUNT_ITEM"`.
 * @internal
 * @documentationMaturity preview
 * @requiredField order
 * @requiredField order.totals
 * @permissionId WIX_STORES.CREATE_ORDERS
 * @adminMethod
 * @deprecated Stores Create Order has been replaced with eCommerce Create Order.
 * @replacedBy com.wix.ecom.orders.v1.Orders.CreateOrder
 * @targetRemovalDate 2024-09-04
 */
export function createOrder(order, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            order: '$[0]',
            additionalOrderSettings: '$[1].additionalOrderSettings',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createOrderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createOrderResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([order, options]);
        const reqOpts = ambassadorWixStoresV2Orders.createOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'order',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @internal
 * @documentationMaturity preview
 * @requiredField filter
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 */
export function bulkFulfillOrders(filter, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            filter: '$[0]',
            sendShippingConfirmationEmail: '$[1].sendShippingConfirmationEmail',
            sendPickupReadyEmail: '$[1].sendPickupReadyEmail',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkFulfillOrdersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkFulfillOrdersResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([filter, options]);
        const reqOpts = ambassadorWixStoresV2Orders.bulkFulfillOrders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'filter',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @internal
 * @documentationMaturity preview
 * @requiredField filter
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 */
export function bulkMarkOrdersAsPaid(filter) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkMarkOrdersAsPaidRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkMarkOrdersAsPaidResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([filter]);
        const reqOpts = ambassadorWixStoresV2Orders.bulkMarkOrdersAsPaid(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'filter',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @internal
 * @documentationMaturity preview
 * @requiredField filter
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 * @deprecated
 * @replacedBy com.wix.ecom.orders.v1.Orders.BulkUpdateOrders
 * @targetRemovalDate 2025-03-02
 */
export function bulkArchiveOrders(filter) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkArchiveOrdersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkArchiveOrdersResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([filter]);
        const reqOpts = ambassadorWixStoresV2Orders.bulkArchiveOrders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'filter',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @internal
 * @documentationMaturity preview
 * @requiredField filter
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 */
export function bulkUnarchiveOrders(filter) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkUnarchiveOrdersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkUnarchiveOrdersResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([filter]);
        const reqOpts = ambassadorWixStoresV2Orders.bulkUnarchiveOrders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'filter',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @internal
 * @documentationMaturity preview
 * @requiredField orderId
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 */
export function addFulfillerEmailWasSentActivity(orderId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { orderId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _addFulfillerEmailWasSentActivityRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _addFulfillerEmailWasSentActivityResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([orderId]);
        const reqOpts = ambassadorWixStoresV2Orders.addFulfillerEmailWasSentActivity(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'orderId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @internal
 * @documentationMaturity preview
 * @requiredField orderId
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 */
export function declineOrder(orderId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            orderId: '$[0]',
            eventTime: '$[1].eventTime',
            reason: '$[1].reason',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _declineOrderRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _declineOrderResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([orderId, options]);
        const reqOpts = ambassadorWixStoresV2Orders.declineOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'orderId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Update Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/update-order)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Updates the email address of a specified order's billing info.
 * If shipping was selected as the delivery method, shipping info email will also be updated.
 * @param orderId - Order ID.
 * @internal
 * @documentationMaturity preview
 * @requiredField orderId
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 * @deprecated Stores Update Order Email has been replaced with eCommerce Update Order.
 * @replacedBy com.wix.ecom.orders.v1.Orders.UpdateOrder
 * @targetRemovalDate 2024-09-04
 */
export function updateOrderEmail(orderId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { orderId: '$[0]', email: '$[1].email' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateOrderEmailRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateOrderEmailResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([orderId, options]);
        const reqOpts = ambassadorWixStoresV2Orders.updateOrderEmail(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'orderId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Update Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/update-order)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Updates the shipping address of a specified order.
 * @param orderId - Order ID.
 * @internal
 * @documentationMaturity preview
 * @requiredField orderId
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 * @deprecated Stores Update Order Shipping Address has been replaced with eCommerce Update Order.
 * @replacedBy com.wix.ecom.orders.v1.Orders.UpdateOrder
 * @targetRemovalDate 2024-09-04
 */
export function updateOrderShippingAddress(orderId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            orderId: '$[0]',
            shippingAddress: '$[1].shippingAddress',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateOrderShippingAddressRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateOrderShippingAddressResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([orderId, options]);
        const reqOpts = ambassadorWixStoresV2Orders.updateOrderShippingAddress(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'orderId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Get Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/get-order)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Returns an order with the provided ID.
 * @param _id - Requested order ID
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @permissionId WIX_STORES.READ_ORDERS
 * @adminMethod
 * @deprecated Stores Get Order has been replaced with eCommerce Get Order.
 * @replacedBy com.wix.ecom.orders.v1.Orders.GetOrder
 * @targetRemovalDate 2024-09-04
 */
export function getOrder(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getOrderRequestV2,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getOrderResponseV2,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixStoresV2Orders.getOrder(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Search Orders](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/search-orders)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Returns a list of up to 100 orders, given the provided paging, sorting and filters.
 * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
 * Hidden orders are not returned.
 * @internal
 * @documentationMaturity preview
 * @permissionId WIX_STORES.READ_ORDERS
 * @adminMethod
 * @deprecated Stores Query Orders has been replaced with eCommerce Search Orders.
 * @replacedBy com.wix.ecom.orders.v1.Orders.SearchOrders
 * @targetRemovalDate 2024-09-04
 */
export function queryOrders(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0].query' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _queryOrdersRequestV2,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _queryOrdersResponseV2,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#orders']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixStoresV2Orders.queryOrders(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Temp method for analytics migration
 * @internal
 * @documentationMaturity preview
 * @permissionId WIX_STORES.READ_ORDERS
 * @adminMethod
 */
export function queryOrdersEventuallyConsistent(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0].query' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _queryOrdersRequestV2,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _queryOrdersResponseV2,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#orders']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixStoresV2Orders.queryOrdersEventuallyConsistent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Create Fulfillment](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/order-fulfillments/create-fulfillment)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Creates a fulfillment (a subset of an order, with line items that are being shipped together) based on the body parameters passed with the request.
 * If the site owner has requested it, calling this request will trigger an email to the customer (based on the Wix store settings).
 * @param orderId - Order ID (to which the fulfillment will be related).
 * @param fulfillment - Fulfillment info.
 * @internal
 * @documentationMaturity preview
 * @requiredField fulfillment
 * @requiredField orderId
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 * @deprecated Stores Create Fulfillment has been replaced with eCommerce Create Fulfillment.
 * @replacedBy com.wix.ecom.orders.fulfillments.v1.Fulfillments.CreateFulfillment
 * @targetRemovalDate 2024-09-04
 */
export function createFulfillment(orderId, fulfillment) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { orderId: '$[0]', fulfillment: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createFulfillmentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createFulfillmentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([orderId, fulfillment]);
        const reqOpts = ambassadorWixStoresV2Orders.createFulfillment(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'orderId',
                'fulfillment',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Update Fulfillment](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/order-fulfillments/update-fulfillment)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Updates an existing fulfillment.
 * @internal
 * @documentationMaturity preview
 * @requiredField identifiers
 * @requiredField identifiers.fulfillmentId
 * @requiredField identifiers.orderId
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 * @deprecated Stores Update Fulfillment has been replaced with eCommerce Update Fulfillment.
 * @replacedBy com.wix.ecom.orders.fulfillments.v1.Fulfillments.UpdateFulfillment
 * @targetRemovalDate 2024-09-04
 */
export function updateFulfillment(identifiers, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            orderId: '$[0].orderId',
            fulfillmentId: '$[0].fulfillmentId',
            fulfillmentTrackingInfo: '$[1].fulfillmentTrackingInfo',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateFulfillmentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateFulfillmentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers, options]);
        const reqOpts = ambassadorWixStoresV2Orders.updateFulfillment(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * <blockquote class='warning'>
 *
 * __Deprecation Notice:__
 *
 * This endpoint has been replaced with
 * [eCommerce Delete Fulfillment](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/order-fulfillments/delete-fulfillment)
 * and will be removed on September 4, 2024.
 *
 * </blockquote>
 *
 * Deletes an existing fulfillment.
 * @internal
 * @documentationMaturity preview
 * @requiredField identifiers
 * @requiredField identifiers.fulfillmentId
 * @requiredField identifiers.orderId
 * @permissionId WIX_STORES.MODIFY_ORDERS
 * @adminMethod
 * @deprecated Stores Delete Fulfillment has been replaced with eCommerce Delete Fulfillment.
 * @replacedBy com.wix.ecom.orders.fulfillments.v1.Fulfillments.DeleteFulfillment
 * @targetRemovalDate 2024-09-04
 */
export function deleteFulfillment(identifiers) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            orderId: '$[0].orderId',
            fulfillmentId: '$[0].fulfillmentId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteFulfillmentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteFulfillmentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['order']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers]);
        const reqOpts = ambassadorWixStoresV2Orders.deleteFulfillment(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=stores-v2-orders.universal.js.map